import type { FormControlledInput } from '@cocoonspace/ui/components/form-controlled-input'
import type { ComponentProps } from 'react'
import type { FieldPath, FieldValues } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@cocoonspace/ui/components/form'
import { Input } from '@cocoonspace/ui/components/input'
import { Trans } from '@lingui/react/macro'

interface ValidatedEmailInputProps extends Omit<
	ComponentProps<typeof FormControlledInput>,
	'render'
> {
	label?: string
	required?: boolean
}

const DidYouMeanButton = ({
	email,
	onClick,
}: {
	email: string
	onClick: VoidFunction
}) => (
	<p className='flex items-center gap-x-1 self-start pt-1 text-xs'>
		<Trans>
			Voulez-vous dire{' '}
			<button
				type='button'
				className='font-semibold underline'
				onClick={onClick}
			>
				{email}
			</button>{' '}
			?
		</Trans>
	</p>
)

export const ValidatedEmailInput = <
	TFieldValues extends FieldValues = FieldValues,
	_TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
	label,
	required,
	...props
}: ValidatedEmailInputProps) => {
	return (
		<FormField
			{...props}
			render={({ field, fieldState }) => (
				<FormItem>
					{!!label && (
						<FormLabel>
							{label}
							{!!required && <sup>*</sup>}
						</FormLabel>
					)}

					<FormControl>
						<Input
							{...field}
							type='email'
						/>
					</FormControl>

					{fieldState.error?.type === 'did_you_mean' ? (
						<DidYouMeanButton
							email={fieldState.error.message!}
							onClick={() => field.onChange?.(fieldState.error?.message as any)}
						/>
					) : (
						<FormMessage />
					)}
				</FormItem>
			)}
		/>
	)
}
